import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { useTranslation } from "ceco-polyglot";
import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";
import environment from "../../environment";

import "./statusButton.scss";
const StatusButton = ({ idRecipe, status, refetchData, ...rest }) => {
  const [loading, setLoading] = useState(false);
  const t = useTranslation();

  function changeStatus() {
    setLoading(true);

    return new Promise((resolve, reject) => {
      const variables = {
        id: idRecipe,
        published: !status,
      };

      commitMutation(environment, {
        mutation: statusButton_update_Mutation,
        variables,

        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }

          setLoading(false);

          resolve(response);
        },

        onError(error) {
          reject(error);
        },
      });
    });
  }

  const textStatus = status ? "published" : "draft";

  return (
    <Button
      loading={loading}
      content={t(`button.${textStatus}`)}
      className={"StatusButton " + textStatus}
      onClick={() =>  {
          changeStatus().then((a) => {
            if(a.recipeUpdate) {
              refetchData()
            }
          })
      }}
      {...rest}
    />
  );
};

export default StatusButton;

const statusButton_update_Mutation = graphql`
  mutation StatusButtonUpdateMutation($id: ID!, $published: Boolean) {
    recipeUpdate(input: { id: $id, published: $published }) {
      recipe {
        id
        name
        published
      }
    }
  }
`;
